import { render } from "./FpIconButton.vue?vue&type=template&id=04d5e882&scoped=true"
import script from "./FpIconButton.vue?vue&type=script&lang=js"
export * from "./FpIconButton.vue?vue&type=script&lang=js"

import "./FpIconButton.vue?vue&type=style&index=0&id=04d5e882&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d5e882"]])

export default __exports__